angular.module('rjmNg.services').factory 'replicationService',[
  "dataWarehouse"
  "CONNECTIONS"
  (dataWarehouse, CONNECTIONS) ->
    replicationService = {}

    replicationService.needsColumnId = (replicationMethod) ->
      requiresColumnId = [
        dataWarehouse.REPLICATION_METHOD.ADD_DATE
        dataWarehouse.REPLICATION_METHOD.UNIX_TS
        dataWarehouse.REPLICATION_METHOD.MODIFIED_AT
        dataWarehouse.REPLICATION_METHOD.MONGO_MODIFIED_AT
      ]
      replicationMethod
      return replicationMethod in requiresColumnId

    replicationService.getDisplayedName = (method, category) ->
      if category is 'inc' and method in dataWarehouse.REPLICATION_INCREMENTAL
        return @getFriendlyName(method)
      else if category is 'full' and method in dataWarehouse.REPLICATION_FULL
        return @getFriendlyName(method)
      else
        return "Select Method"

    replicationService.getFriendlyName = (method) ->
      dataWarehouse.REPLICATION_NAMES[method]

    # Returns a list of the allowed replication methods
    replicationService.getAllowedReplicationMethods = (databaseType, columns) ->
      methods = (value for key, value of dataWarehouse.REPLICATION_METHOD)
      allowed = (method for method in methods when @_canUseMethod(method, databaseType, columns))
      return allowed

    # Returns an array of keys valid for replication for this type
    replicationService.getReplicationKeys = (cols, repType) ->
      validKeys = (col for col in cols when replicationService._isValidRepKey(col, repType))

    replicationService._isValidRepKey = (col, repType) ->
      supportedDataTypes = ['inst']
      if repType in [dataWarehouse.REPLICATION_METHOD.MONGO_MODIFIED_AT, dataWarehouse.REPLICATION_METHOD.MODIFIED_AT]
        supportedDataTypes.push 'int'
      return (col.data_type.type in supportedDataTypes and col.type is 'remote_column')

    # Some replication methods have restrictions
    replicationService._canUseMethod = (method, databaseType, columns) ->
      methods = dataWarehouse.REPLICATION_METHOD
      if method is methods.NONE
        return true
      else if method is methods.FULL_TABLE and @_dbSupportsFullTable(databaseType)
        return true
      else if databaseType is CONNECTIONS.TYPES.REDSHIFT
        return @_isAllowedInRedshift(method, columns)
      else if @_isMongo(databaseType)
        return @_isMongoType(method) and @_hasRequiredMongoColumns(method, columns)
      else if method is dataWarehouse.REPLICATION_METHOD.ADD_DATE and @_includesDataTypes(columns, ['inst'])
        return true
      else if method is dataWarehouse.REPLICATION_METHOD.MODIFIED_AT and @_includesDataTypes(columns, ['inst', 'int']) and @_hasValidRechecksForModifiedAt(columns)
        return true
      else if method is methods.UNIX_TS and @_includesDataTypes(columns, ['unix_timestamp'])
        return true
      else if method is methods.SINGLE_AUTO_INC_PK and @_hasPk(columns)
        return true
      else if method is methods.PK_BATCH and @_hasPk(columns)
        return true
      else
        return false

    # MODIFIED_AT doesn't require configuring a recheck option, so we show it only in case recheck is NEVER or ONCE
    replicationService._hasValidRechecksForModifiedAt = (columns) ->
      validRecheckFrequencies = [dataWarehouse.RECHECK_TYPE.NEVER, dataWarehouse.RECHECK_TYPE.ONCE]
      for column in columns when column.type isnt "derivative" and column.recheck not in validRecheckFrequencies
        return false
      return true

    # Returns true if this is Mongo or not one of our native replicators (ie. 3rd party API)
    replicationService._isMongo = (type) ->
      natives = CONNECTIONS.DB_TYPES
      return (type is CONNECTIONS.TYPES.MONGO) or (type not in natives)

    # We only have two db types that don't support full table replication
    replicationService._dbSupportsFullTable = (type) ->
      supported = [
        CONNECTIONS.TYPES.MYSQL
        CONNECTIONS.TYPES.MSSQL
        CONNECTIONS.TYPES.POSTGRES
      ]
      return type in supported

    replicationService._isAllowedInRedshift = (method, columns) ->
      methods = dataWarehouse.REPLICATION_METHOD
      if method is methods.INCREMENTAL_REDSHIFT_UNLOAD
        return @_hasUniquePk(columns)
      else
        redshiftSupported = [
          dataWarehouse.REPLICATION_METHOD.REDSHIFT_UNLOAD
          dataWarehouse.REPLICATION_METHOD.NONE
        ]
        return method in redshiftSupported

    replicationService._hasRequiredMongoColumns = (method, columns) ->
      methods = dataWarehouse.REPLICATION_METHOD
      if method is methods.MONGO_MODIFIED_AT
        return @_includesDataTypes(columns, ['inst', 'int'])
      else if method is methods.MONGO_ID or method is methods.MONGO_BATCH
        return @_hasPk(columns)
      else if method is methods.FULL_TABLE
        return true
      else if method is methods.NONE
        return true
      else
        return false

    replicationService._isMongoType = (method) ->
      mongoMethods = [
        dataWarehouse.REPLICATION_METHOD.MONGO_ID
        dataWarehouse.REPLICATION_METHOD.MONGO_BATCH
        dataWarehouse.REPLICATION_METHOD.MONGO_MODIFIED_AT
      ]
      return method in mongoMethods

    replicationService._includesDataTypes = (columns, types) ->
      for column in columns when column.data_type.type in types
        return true
      return false

    replicationService._hasPk = (columns) ->
      for column in columns when column.is_primary_key
        return true
      return false

    replicationService._hasUniquePk = (columns) ->
      keys = (column for column in columns when column.is_primary_key)
      return keys.length is 1

    replicationService
]
